export default __webpack_public_path__ + "static/media/about-usbanner.c810473b.jpg";